export default {
  default_browser_tag: 'FoodAmigos - Ordina online',
  seo: {
    title: '{{name}} - ordina cibo online a {{city}}',
    description: '{{name}} a {{city}}. Menu ufficiale. Risparmia e ordina online.',
  },
};
